<template>
  <div class="filter-cell" @click="onClick">
    <p class="label van-ellipsis" :class="{ active }" style="min-width: 28px">{{ label }}</p>
    <span class="caret-wrapper">
      <i v-if="showAscending" class="sort-caret ascending" :class="{ active: active === 'ascending' }"></i>
      <i
        class="sort-caret descending"
        :class="{ active: active === 'descending' || (hasValueActive && active), up: !showAscending }"
      ></i>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    label: '',
    active: '',
    showAscending: {
      type: Boolean,
      default: true
    },
    hasValueActive: false
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  }
};
</script>

<style lang="less" scoped>
.filter-cell {
  word-wrap: normal;
  vertical-align: middle;
  width: 100%;
  display: flex;
  align-items: center;
  color: #595959;
  p.label {
    &.active {
      color: #1e8dff;
    }
  }
  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 24px;
    width: 12px;
    min-width: 12px;
    margin-left: 2px;
    cursor: pointer;
    overflow: initial;
    position: relative;
    .sort-caret {
      width: 0;
      height: 0;
      border: 4px solid transparent;
      position: absolute;
      left: 2px;
      border-radius: 2px;
      &.ascending {
        border-bottom-color: #d9d9d9;
        top: 3px;
        &.active {
          border-bottom-color: #1e8dff;
        }
      }
      &.descending {
        border-top-color: #d9d9d9;
        bottom: 3px;
        &.up {
          bottom: 5px;
        }
        &.active {
          border-top-color: #1e8dff;
        }
      }
    }
  }
}
</style>